
namespace Matrix.Visualizer {

    @Serenity.Decorators.registerClass()
    export class GraphEdgeDialog extends Serenity.EntityDialog<GraphEdgeRow, any> {
        protected getFormKey() { return GraphEdgeForm.formKey; }
        protected getIdProperty() { return GraphEdgeRow.idProperty; }
        protected getLocalTextPrefix() { return GraphEdgeRow.localTextPrefix; }
        protected getNameProperty() { return GraphEdgeRow.nameProperty; }
        protected getService() { return GraphEdgeService.baseUrl; }

        protected form = new GraphEdgeForm(this.idPrefix);

    }
}